<template>
  <div>
    <div v-for="(slide, index) in slides" :key="index"
         style="margin-bottom: 1rem; border: 1px solid #ccc; padding: 1rem; border-radius: 4px;">
      <label :for="`slide-code-${index}`">Slide {{ index + 1 }}</label>
      <textarea
          :id="`slide-code-${index}`"
          v-model="slide.code"
          rows="4"
          style="width: 100%; margin-top: 0.5rem;"
          placeholder="Enter slide code here..."
      ></textarea>
      <div class="d-flex justify-content-between">
        <button type="button" @click="moveSlideUp(index)" :disabled="index === 0" class="btn btn-link"
                aria-label="Move Slide Up">
          <i class="fas fa-arrow-up"></i>
        </button>
        <button type="button" @click="moveSlideDown(index)" :disabled="index === slides.length - 1" class="btn btn-link"
                aria-label="Move Slide Down">
          <i class="fas fa-arrow-down"></i>
        </button>
        <button type="button" @click="removeSlide(index)" class="btn btn-danger ml-auto" aria-label="Remove Slide">
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </div>
    <button type="button" @click="addSlide" class="btn btn-primary">
      Add Slide
    </button>
  </div>
</template>

<script>
import _ from 'lodash'
import layoutMixin from "../../mixins/layout";

export default {
  name: 'Carousel',
  mixins: [layoutMixin],
  data() {
    const slides = _.get(this.source, 'slides', [])
    return {
      slides: slides
    }
  },
  methods: {
    addSlide() {
      this.slides.push({code: ''})
    },
    removeSlide(index) {
      this.slides.splice(index, 1)
    },
    moveSlideUp(index) {
      if (index > 0) {
        const temp = this.slides[index - 1]
        this.slides.splice(index - 1, 1, this.slides[index])
        this.slides.splice(index, 1, temp)
      }
    },
    moveSlideDown(index) {
      if (index < this.slides.length - 1) {
        const temp = this.slides[index + 1]
        this.slides.splice(index + 1, 1, this.slides[index])
        this.slides.splice(index, 1, temp)
      }
    },
    setContent() {
    },
    getValue() {
      const content = {
        slides: this.slides
      }

      return content
    }
  }
}
</script> 